module.exports = __webpack_public_path__ + "img/studio-3.3f242763.jpg";